import styled from 'styled-components'

export const SectionTitle = styled.h5`
  text-transform: uppercase;
  color: ${p => p.theme.colors.secondary.dark};
  margin-top: auto;
  margin-bottom: auto;
  margin-block-start: auto;
  margin-block-end: auto;
  margin-inline-start: auto;
  margin-inline-end: auto;
  font-weight: 700;
  line-height: 1em;
`